<template>
  <p-container class="widget-shop-article-detail-testing-page page automation test">
    <il-widget-tester
      v-model="page.widgetConfig"
      title="Shop Article Detail Widget Test"
    ></il-widget-tester>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import IlWidgetTester from '../../../../../components/il-widget-tester.vue';
  import WidgetShopArticleDetailTestingPage from './widget-shop-article-detail-testing.vue.model';

  export default Vue.extend({
    name: 'WidgetShopTesting',
    role: ['Admin', 'Hostadmin'],
    auth: true,
    components: {
      IlWidgetTester,
    },
    data: () => ({
      page: new WidgetShopArticleDetailTestingPage(),
    }),
    mounted() {
      this.page.initialize();
    },
  });
</script>
